import axios from '@/api/axios'

const getDirectory = () => {
  return axios.get('/directory')
}

const addDirectory = directory => {
  return axios.post('/directoryList', directory)
}

const getDirectoryList = type => {
  return axios.get(`/directoryList?type=${type}`)
}

const getDirectoryListAll = () => {
  return axios.get(`/directoryList`)
}

const deleteDirectoryList = id => {
  return axios.delete(`/directoryList/${id}`)
}

export default {
  getDirectory,
  addDirectory,
  getDirectoryList,
  deleteDirectoryList,
  getDirectoryListAll
}
